import { THEME } from '@enmon/commons';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  .ant-dropdown,
  .ant-tabs-dropdown {
    .ant-dropdown-menu,
    .ant-tabs-dropdown-menu {
      .ant-dropdown-menu-item,
      .ant-tabs-dropdown-menu-item {
        background-color: ${({ theme }) => theme.color.grey.white};
        :hover {
          background-color: ${({ theme }) => theme.color.semantic.primary.background.hoverWeak};
        }
      }
    }
  }

  .ant-table-row-selected {
    .ant-table-selection-column,
    .ant-table-cell {
      background-color: ${({ theme }) => theme.color.semantic.primary.background.hoverWeak} !important;
    }
  }

  .ant-form-item-label {
    font-family: ${THEME.typography.fontFamily.poppins}
  }

    // selection color
  ::selection {
    background-color: ${THEME.color.semantic.primary.background.hover};
    color: ${THEME.color.core.white};
  }
  ::-webkit-selection {
    background-color: ${THEME.color.semantic.primary.background.hover};
    color: ${THEME.color.core.white};
  }
  ::-moz-selection {
    background-color: ${THEME.color.semantic.primary.background.hover};
    color: ${THEME.color.core.white};
  }
`;

export default GlobalStyle;
